import { VenueCatering, VenueAlcohol } from '../types/venue-profile';

const TWS = {
    getStaticUrl: (): string => '/static/',
    ANALYTICS: {
        logEvent: <T>(name: string, props?: { [key: string]: T }, cb?: () => void) => ({}),
        logCurUserProps: (props: { [key: string]: number | string }) => ({}),
    },
};

const getStaticUrl = () => TWS.getStaticUrl();
const logAnalyticsEvent = <T>(name: string, props?: { [key: string]: T }, cb?: () => void): void => {
    TWS.ANALYTICS.logEvent(name, props, cb);
};

const logCurUserProps = (props: { [key: string]: number | string }): void => {
    TWS.ANALYTICS.logCurUserProps(props);
};

const getUSAStates = () => [
    ['AL', 'Alabama'],
    ['AK', 'Alaska'],
    ['AS', 'American Samoa'],
    ['AZ', 'Arizona'],
    ['AR', 'Arkansas'],
    ['AA', 'Armed Forces Americas'],
    ['AE', 'Armed Forces Europe'],
    ['AP', 'Armed Forces Pacific'],
    ['CA', 'California'],
    ['CO', 'Colorado'],
    ['CT', 'Connecticut'],
    ['DE', 'Delaware'],
    ['DC', 'District of Columbia'],
    ['FL', 'Florida'],
    ['GA', 'Georgia'],
    ['GU', 'Guam'],
    ['HI', 'Hawaii'],
    ['ID', 'Idaho'],
    ['IL', 'Illinois'],
    ['IN', 'Indiana'],
    ['IA', 'Iowa'],
    ['KS', 'Kansas'],
    ['KY', 'Kentucky'],
    ['LA', 'Louisiana'],
    ['ME', 'Maine'],
    ['MD', 'Maryland'],
    ['MA', 'Massachusetts'],
    ['MI', 'Michigan'],
    ['MN', 'Minnesota'],
    ['MS', 'Mississippi'],
    ['MO', 'Missouri'],
    ['MT', 'Montana'],
    ['NE', 'Nebraska'],
    ['NV', 'Nevada'],
    ['NH', 'New Hampshire'],
    ['NJ', 'New Jersey'],
    ['NM', 'New Mexico'],
    ['NY', 'New York'],
    ['NC', 'North Carolina'],
    ['ND', 'North Dakota'],
    ['MP', 'Northern Mariana Islands'],
    ['OH', 'Ohio'],
    ['OK', 'Oklahoma'],
    ['OR', 'Oregon'],
    ['PA', 'Pennsylvania'],
    ['PR', 'Puerto Rico'],
    ['RI', 'Rhode Island'],
    ['SC', 'South Carolina'],
    ['SD', 'South Dakota'],
    ['TN', 'Tennessee'],
    ['TX', 'Texas'],
    ['UT', 'Utah'],
    ['VT', 'Vermont'],
    ['VI', 'Virgin Islands'],
    ['VA', 'Virginia'],
    ['WA', 'Washington'],
    ['WV', 'West Virginia'],
    ['WI', 'Wisconsin'],
    ['WY', 'Wyoming'],
];

export const getCateringVerboseName = (catering: VenueCatering): string => {
    switch (catering) {
        case VenueCatering.BYO:
            return 'BYO';
        case VenueCatering.list:
            return 'Choose from List';
        case VenueCatering.provided:
            return 'Provided';
        default:
            return catering;
    }
};

export const getAlcoholVerboseName = (catering: VenueAlcohol): string => {
    switch (catering) {
        case VenueAlcohol.byo:
            return 'BYO';
        case VenueAlcohol.provided:
        case VenueAlcohol.providedByDrink:
            return 'Provided';
        default:
            return catering;
    }
};

export { getStaticUrl, getUSAStates, logAnalyticsEvent, logCurUserProps };
